import { useState } from 'react';

const useAnchorEl = () => {
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return {
		anchorEl,
		handleClick,
		handleClose,
	};
};

export default useAnchorEl;
